import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class NameColumn extends Column {
    title = 'payroll.setup.padAgreementLogs.name';
    type = CellDisplay.string;
    property = 'name';
    displayWidth = 20;
}
